import React, { PropTypes } from "react";
import ComponentRegistry from "Fratello/Common/ComponentRegistry";

export default function Vats({ title, value }) {
    const Price = ComponentRegistry.get("Price");

    const rates = Object.keys(value).map(rate => <div key={rate}>
        <div className="clearfix">
            <div className="pull-left">{rate} %</div>
            <Price className="pull-right" value={value[rate]} />
        </div>
    </div>);

    return (
      <div>
        <div className="row">
            <div className="col-xs-12 col-sm-6 col-sm-offset-6">
                <div className="row">
                    <div className="col-xs-6 column text-right">{title}</div>
                    <div className="col-xs-6 column text-right">{rates}</div>
                </div>
            </div>
        </div>

      </div>
    );
}

Vats.propTypes = {
    title: PropTypes.string.isRequired,
    value: PropTypes.objectOf(PropTypes.string).isRequired,
};



// WEBPACK FOOTER //
// ./app/Resources/public/rosco/js/Basket/Atoms/Vats.jsx